// These only work inside the browser
import { isBrowser } from "./browser";

/**
 * Retrieve an existing cookie or an empty string.
 */
const get = (name: string): string => {
    const r: string[] | null = document.cookie.match(`\\b${name}=([^;]*)\\b`);
    return r ? r[1] : "";
};

/**
 * Set a cookie or replace an existing cookie.
 */
const set = (name: string, value: string, days: number = 0): string => {
    if (!isBrowser()) {
        return "";
    }
    let expires = "";

    if (days) {
        const date: Date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = `; expires=${date.toUTCString()}`;
    }

    document.cookie = `${name}=${value};expires=${expires};path=/`;
    return document.cookie;
};

/**
 * Delete an existing cookie. (named remove due to delete being a reserved word)
 */
const remove = (name: string): void => {
    set(name, "", -1);
};

const Cookies = {
    remove,
    get,
    set
};

export default Cookies;
